import {BaseComponent} from './base-component.js'
import {customElement, property} from 'lit/decorators.js'
import {html, css, TemplateResult, CSSResultGroup} from 'lit'

@customElement('il-loader')
export default class LoaderComponent extends BaseComponent {
  @property({type: Boolean}) small = false
  @property({type: Boolean}) tiny = false
  @property({type: Boolean, attribute: 'ignore-theme' }) ignoreTheme = false

  static override styles = [
    BaseComponent.styles,
    css`
      .il-loader-container {
        display: flex;
      }

      .il-loader-container.il-loader-container--ignore-theme .il-loader {
        border-color: var(--il-color-neutrals-100);
        border-bottom-color: var(--il-color-neutrals-250);
      }

      .il-loader {
        width: 36px;
        height: 36px;
        border: 6px solid var(--il-color-neutrals-100);
        border-bottom-color: var(--il-color-accent-200);
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
      }

      .il-loader.il-loader--small {
        width: 28px;
        height: 28px;
        border-width: 5px;
      }

      .il-loader.il-loader--tiny {
        width: 20px;
        height: 20px;
        border-width: 3px;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ] as CSSResultGroup

  override render (): TemplateResult {
    return html`
      <div
        class="
          ${this.baseCSSClass}
          il-loader-container
          ${this.ignoreTheme ? 'il-loader-container--ignore-theme' : ''}
        "
        data-test-iliad-loader-container
      >
        <div
          class="
            il-loader
            ${this.small ? 'il-loader--small' : ''}
            ${this.tiny ? 'il-loader--tiny' : ''}
          "
          data-test-iliad-loader
        ></div>
      </div>
    `
  }
}
